var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.notifications),function(notification){return _c('notification',{key:notification.id,attrs:{"notification":notification}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }